export default __webpack_public_path__ + "static/media/zahrada.575a4c58.jpeg";